import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { map, catchError } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})

export class ManageForeclosureAuctionService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private _http: HttpClient, private _global: GlobalService) { }

  getStates(): Observable<any> {
    const api = (<any>_GlobalNS).api.allStates;
    let params = new HttpParams();
    return this._http.get<any>(`${api}`, { params })
      .pipe(
        map((response) => { return this.formatState(response) }),
        catchError(error => { return throwError(error) })
      );
  }

  formatState(response) {
    let data = response.data;
    let states = [];
    let tempArray: any = {};
    data.map((items) => {
      tempArray = {
        label: items.StateName,
        value: items.StateCode,
        StateName: items.StateName,
        StateCode: items.StateCode
      }
      states.push(tempArray);
    })
    return states;
  }

  getCounty(stateCode: string): Observable<any> {
    const api = (<any>_GlobalNS).api.county;
    let params = new HttpParams();
    params = params.set('StateCode', stateCode);
    return this._http.get<any>(`${api}`, { params });
  }

  getForeclosureAuctionLocationData(searchParams): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.search;
    let params = new HttpParams();
    params = params.set('state', searchParams.State)
      .set('county', searchParams.County)
      .set('locationAddress', searchParams.LocationAddress)
      .set('locationDetails', searchParams.LocationDetails)
      .set('statutaryLocation', searchParams.StatutaryLocation)
      .delete('state', '')
      .delete('county', '')
      .delete('locationAddress', '')
      .delete('locationDetails', '')
      .delete('statutaryLocation', '');
    return this._http.get<any>(`${api}`, { params });
  }

  save(params): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.create;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, params, this.httpOptions);
  }

  update(params): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.update;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post<any>(`${api}&eqrf=${eqrf}`, params, this.httpOptions);
  }

  delete(matrixIds): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.delete;
    let params = new HttpParams();
    params = params.set('FcMatrixID', matrixIds);
    return this._http.get<any>(`${api}`, { params });
  }
  getSelectorsData(): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.changeLogSelectors;
    return this._http.get<any>(`${api}`);
  }
  getChangeLogData(changeLogParams): Observable<any> {
    const api = (<any>_GlobalNS).api.foreclosureAuctionLocation.changeLog;
    let params = new HttpParams();
    params = params.set('StateCode', changeLogParams.StateCode)
                    .set('ChangedBy', changeLogParams.ChangedBy)
                    .set('County', changeLogParams.County)
                    .set('FromDate', changeLogParams.FromDate)
                    .set('ToDate', changeLogParams.ToDate)
                    .delete('ChangedBy', '')
                    .delete('County', '')
                    .delete('FromDate', '')
                    .delete('ToDate', '')
                    .delete('StateCode','');
    return this._http.get<any>(`${api}`,{params});
  }

}